import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

export const fetchHornedStatusCodeList = createAsyncThunk(
  "hornedStatus/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get("/api/sif/drob/rogatost");
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const hornedStatusSlice = createSlice({
  name: "hornedStatus",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHornedStatusCodeList.fulfilled, (state, action) => {
        state.list = action.payload;
        state.isLoading = true;
      })
      .addCase(fetchHornedStatusCodeList.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchHornedStatusCodeList.pending, (state, _) => {
        state.isLoading = false;
        state.error = null;
      });
  },
});

export default hornedStatusSlice.reducer;
